import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logo-trello",
  "use": "logo-trello-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"#fff\" viewBox=\"0 0 512 512\" id=\"logo-trello\"><rect width=\"512\" height=\"512\" fill=\"#0079bf\" rx=\"15%\" /><rect width=\"132\" height=\"188\" x=\"284\" y=\"95\" rx=\"23\" /><rect width=\"132\" height=\"296\" x=\"97\" y=\"95\" rx=\"23\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol